import { render, staticRenderFns } from "./DesktopFooter.vue?vue&type=template&id=5e4405da&scoped=true"
import script from "./DesktopFooter.vue?vue&type=script&lang=js"
export * from "./DesktopFooter.vue?vue&type=script&lang=js"
import style0 from "./DesktopFooter.vue?vue&type=style&index=0&id=5e4405da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4405da",
  null
  
)

export default component.exports